// src/services/artistStorageService.ts
// This service handles local storage of artist data

/**
 * Interface for the selected artist data that will be stored
 */
export interface StoredArtist {
  id: string;
  spotifyId: string;
  name: string;
}

/**
 * The key used for storing selected artist in localStorage
 */
const STORAGE_KEY = 'selected_artist';

/**
 * Save the selected artist to localStorage
 */
export const saveSelectedArtist = (artist: StoredArtist): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(artist));
  } catch (error) {
    console.error('Error saving artist to localStorage:', error);
  }
};

/**
 * Get the selected artist from localStorage
 */
export const getSelectedArtist = (): StoredArtist | null => {
  try {
    const storedArtist = localStorage.getItem(STORAGE_KEY);
    if (storedArtist) {
      return JSON.parse(storedArtist) as StoredArtist;
    }
    return null;
  } catch (error) {
    console.error('Error retrieving artist from localStorage:', error);
    return null;
  }
};

/**
 * Clear the selected artist from localStorage
 */
export const clearSelectedArtist = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing artist from localStorage:', error);
  }
};